/* eslint-disable @typescript-eslint/camelcase */
import intl from 'react-intl-universal'

import { hasPermission } from '../services/permission'
import { verifyLanguageLayout } from '../../util/rtl-utils'

function directive(
  $rootScope,
  $compile,
  metaTemplatesService,
  picklistService
) {
  return {
    restrict: 'A',
    replace: false,
    link: function (scope, elem, attrs) {
      const { type } = attrs

      const { settings } = (scope.companySettings &&
        scope.companySettings.v2 &&
        scope.companySettings.v2[scope.settingsProp].find(
          (o) => o.key === type
        )) || { settings: {} }
      const templateDefinition = metaTemplatesService.getTemplate(type)
      const template =
        typeof templateDefinition === 'function'
          ? templateDefinition(settings)
          : templateDefinition
      const cleanedTmpl = template.replace(
        /^(<[^\s>]+)([>\s])/,
        '$1 ng-model="' + attrs.ngModel + '"$2'
      )

      if (template.indexOf('data-is-picklist') > -1) {
        const el = $(elem[0]).find('[data-is-picklist]')
        scope.key = el.data('key')
        scope.path = el.data('path')
      }

      scope.type = type
      scope.settings = settings
      scope.isRequired = settings.requiredSave
      scope.hideField = settings.hideField

      const compiled = $compile(cleanedTmpl)(scope)
      elem.append(compiled)
    },
    scope: {
      type: '@',
      storyObj: '=',
      websitesObj: '=',
      userRolesAuth: '=',
      picklists: '=',
      companySettings: '=',
      settingsProp: '@',
      meta: '=',
    },
    controller: [
      'toastr',
      '$rootScope',
      '$scope',
      '$timeout',
      'storyService',
      '$filter',
      function (toastr, $rootScope, $scope, $timeout, storyService, $filter) {
        $scope.commaSplit = (value, path) => {
          const parts = value
            .split(/\s*,\s*/g)
            .filter((val) => val.length && val)
          const pathParts = path.split('.')
          const key = pathParts.pop()
          pathParts.reduce((o, p) => o[p] || {})[key] = parts
        }

        // converts the ngTagsInput array of objects to plain array
        $scope.tagsToArray = (tags) => tags.map((t) => t.text)

        $scope.canModerateComments = () => {
          return hasPermission($scope.userRolesAuth.story.commentModeration)
        }

        // HOT FIXES
        $rootScope.$on('DISPATCH', (info, action) => {
          if (action.type === 'REQUIRED_FIELDS') {
            $scope.isRequiredNotify = !!action.fields.find(
              (o) => o.key === $scope.type
            )
          }
        })

        $scope.createPicklistEntry = (storyObj, path, item, key) => {
          const entry = {
            id: $filter('isPickedSlug')(item),
            text: item,
            order: picklistService.obtain(key).picklist.length || 0,
            active: true,
            default: false,
          }
          const picklist = picklistService.addToPicklistStructureButDontPersistYet(
            entry,
            key
          )
          if (picklist === null) {
            toastr.error(intl.get('metaElement.createPicklistEntry.error'))
          } else if (picklistService.validate(picklist)) {
            const { picklists } = picklistService.get()
            const data = picklistService.preSave(
              key,
              picklists,
              picklist,
              picklist.orderType
            )
            picklistService.commit(data).then(() => {
              $scope.picklists[key].picklist.push(entry)
              $scope.handleSelection(storyObj, path, entry, key)
            })
          } else {
            toastr.info(intl.get('metaElement.createPicklistEntry.info'))
          }
        }
        $scope.handleSelection = (storyObj, path, item) => {
          // I'm sure there is a cooler way to do this.
          /*
           * Travel down the scope via the ${path} until we find the
           *  property we'd like to override in the storyObj.
           */
          const pathParts = path.split('.')
          let idx = 0
          let focus = storyObj
          const pathPartCount = pathParts.length - 1
          for (idx; idx < pathPartCount; idx++) {
            focus = focus[pathParts[idx]]
          }
          focus[pathParts[idx]] = item.id
          // Update to RTL direction when using `freeText` dropdown
          verifyLanguageLayout(item.id)
          storyService.setStory($scope.storyObj, true)
        }

        $scope.plannedDateLimit = 'past'
        $scope.orgTimezone = $rootScope.globalSettings.timezone

        $scope.updatePlannedDate = (time) => {
          $scope.storyObj.planning.scheduling.planned_publish_date = time
          $scope.change()
        }

        // Update to RTL direction when using `freeText`
        $scope.blur = (e) => {
          if (
            e.target?.attributes?.['ng-model']?.value === 'storyObj.language'
          ) {
            verifyLanguageLayout(e.target?.value)
          }
        }

        // Encapsolating this within a service would be...ideal.
        $scope.change = (isSelect) => {
          // only do this for picklists
          if ($scope.path) {
            const model = $scope.path
              .split('.')
              .reduce((acc, branch) => acc[branch], $scope.storyObj)
            // if we are overriding picklist default
            // need to track it in additional props so as override default
            // on next page refresh
            $scope.storyObj.additional_properties = {
              ...($scope.storyObj.additional_properties || {}),
              picklistOverride: [
                ...(
                  $scope.storyObj.additional_properties.picklistOverride || []
                ).filter((o) => {
                  return o.path !== $scope.path
                }),
                { path: $scope.path, reset: model === '' },
              ],
            }
          }
          // Update to RTL direction when using `single` (select)
          if ($scope.type === 'language' && isSelect) {
            verifyLanguageLayout($scope.storyObj.language)
          }

          if (['creditline', 'source_type'].indexOf($scope.type) > -1) {
            $scope.storyObj.source = {
              ...$scope.storyObj.source,
            }
          }

          storyService.setStory($scope.storyObj, true)

          // Warning for saving
          storyService.isDirty(true)
        }

        // Handle special requirement for syndication
        if ($scope.type === 'syndication') {
          $scope.syndicationOpts = []
          if ($scope.storyObj.syndication) {
            if ($scope.storyObj.syndication.external_distribution) {
              $scope.syndicationOpts.push('external_distribution')
            }

            if ($scope.storyObj.syndication.search) {
              $scope.syndicationOpts.push('search')
            }

            if ($scope.syndicationOpts.length === 0) {
              $scope.syndicationOpts.push('')
            }
          }

          $scope.syndicationChange = () => {
            if ($scope.syndicationOpts.length > 0) {
              if (
                $scope.storyObj.syndication &&
                $scope.syndicationOpts.indexOf('') !== -1
              ) {
                if (
                  $scope.storyObj.syndication.external_distribution ||
                  $scope.storyObj.syndication.search
                ) {
                  // When None is selected, external_distribution and search have to be deselected
                  $scope.syndicationOpts = ['']
                } else {
                  // When external_distribution or search is selected, None has to be deselected
                  $scope.syndicationOpts = $scope.syndicationOpts.filter(
                    (opt) => opt !== ''
                  )
                }
              }
              $scope.storyObj.syndication = {
                external_distribution:
                  $scope.syndicationOpts.indexOf('external_distribution') !==
                  -1,
                search: $scope.syndicationOpts.indexOf('search') !== -1,
              }
            } else {
              // When nothing selected, unset the syndication in story so we can block publishing if it's set to required
              delete $scope.storyObj.syndication
            }
            $scope.change()
          }
        }

        // add correction
        $scope.addCorrection = () => {
          if (!$scope.storyObj.corrections) {
            $scope.storyObj.corrections = [{ text: '', type: 'correction' }]
          } else {
            $scope.storyObj.corrections.push({ text: '', type: 'correction' })
          }
          // weird...
          $scope.change()
        }
        // prevent $$hashtag bs
        $scope.setCorrection = () => {
          $scope.storyObj.corrections = ($scope.storyObj.corrections || []).map(
            (o) => {
              return { text: o.text, type: 'correction' }
            }
          )
          $scope.change()
        }

        $scope.removeIndex = (theArray, index) => {
          theArray.splice(index, 1)
          storyService.isDirty(true)
        }

        $rootScope.$on('SAVE_SUCCESS', (evt, data) => {
          $scope.storyObj = data.story
        })
      },
    ],
  }
}

export default [
  '$rootScope',
  '$compile',
  'metaTemplatesService',
  'picklistService',
  'storyService',
  'lazyWatcherService',
  directive,
]
